import {
  Box,
  Text,
  Flex,
  HStack,
  Image as ChakraImage,
  IconButton,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
} from "@chakra-ui/react";
import smrImage7 from "@/assets/images/smr_img7.png";
import SmrImageUploader from "./smrImageUpLoader";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { selectUser } from "@/reducer/userslice";
import { RiCloseCircleFill } from "@remixicon/react";
import { selectMode, updateDesign, updateRefStyle } from "@/reducer/modeslice";
import { imageUploaded } from "@/services/api/thunks/image";
import { RefStyle } from "@/types/design";
import { useEffect } from "react";
import { refreshGenCoin } from "@/store/actions";


const SmrStyle = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectUser);
  const { design } = useAppSelector(selectMode);

  const handleChangeSmrStyle = (files: File[]) => {
    files.map(async(file) => {
      const result:any = await dispatch (
        imageUploaded({
          file,
          image_category: "user",
          is_intermediate: false,
          imageType: "STYLE_IMAGE",
          session_id:user.id
        })
      );

      if (result) {
        let currentStyleImages:RefStyle[] =design.refstyle ? [...design.refstyle] : [];
        currentStyleImages.push({
          url: result.payload.image_url,
          weight: 1,
        });
        dispatch(updateRefStyle(currentStyleImages))
      }
    });
  };

  const handleDeleteSmrStyle = (image: RefStyle) => {
    let currentStyleImages = [...design.refstyle];
    const NewStyleArr = currentStyleImages.filter(
      (item) => item.url !== image.url
    );
    const newdesign = { ...design, refstyle: NewStyleArr };
    dispatch(updateDesign(newdesign));
  };

  const handleChangeStyleStrength = (value: number) => {
    let currentStyleImages = [...design.refstyle];
    currentStyleImages[design.refstyle.length-1] = {
      ...currentStyleImages[design.refstyle.length-1],
      weight: value/100,
    };
    const newdesign = { ...design, refstyle: currentStyleImages };
    dispatch(updateDesign(newdesign));
  };

  useEffect(()=>{
    dispatch(refreshGenCoin())
  },[dispatch,design.refstyle])

  return (
    <Box
      background="linear-gradient(40.59deg, #496AE1 72.71%, #172147 86.65%)"
      borderRadius="10px"
      p="1px"
      mt="20px"
    >
      <Box
        p="20px"
        borderRadius="10px"
        background="linear-gradient(237.85deg, #172248 9.18%, #161922 67.26%)"
      >
        <HStack>
          <ChakraImage src={smrImage7} />
          <Text fontSize={"16px"} color="#FFFFFF">
            风格参考图
          </Text>
        </HStack>

        <Box mt="20px">
          {design.refstyle && design.refstyle.length> 0 && (
            <Box
              h="200px"
              bg={"#0C0B10"}
              borderRadius="10px"
              position={"relative"}
            >
              <ChakraImage
                w="100%"
                h="200px"
                objectFit={"contain"}
                src={design.refstyle[design.refstyle.length - 1].url}
              />
              <IconButton
                variant="unstyled"
                aria-label="delete"
                fontSize="16px"
                position={"absolute"}
                top="5px"
                right={"5px"}
                w="18px"
                minW={"18px"}
                h="18px"
                icon={<RiCloseCircleFill color="#6C7596" size={"18px"} />}
                onClick={()=>handleDeleteSmrStyle(design.refstyle[design.refstyle.length - 1])}
              />
            </Box>
          )}
          {((design.refstyle && design.refstyle?.length < 1) ||
          !design.refstyle) && (
            <SmrImageUploader upDateImages={handleChangeSmrStyle} />
          )}

          <Flex mt="10px" alignItems={"center"} gap="12px">
            <Text fontSize={"14px"} color="#6C7596">
            参考图强度
            </Text>
            <Slider
              flex={1}
              value={design.refstyle.length> 0? Math.floor(design.refstyle[design.refstyle.length - 1].weight * 100) : 0}
              step={1}
              min={1}
              max={100}
              onChange={handleChangeStyleStrength}
            >
              <SliderTrack bg="#6C7596" h="8px" borderRadius={"8px"}>
                <SliderFilledTrack bg="linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)" />
              </SliderTrack>
              <SliderThumb bg="#FFFFFF" boxSize={"18px"} />
            </Slider>
            <Text fontSize={"14px"} color="#FFFFFF">
              {design.refstyle.length> 0? Math.floor(design.refstyle[design.refstyle.length - 1].weight * 100) : 0}%
            </Text>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

export default SmrStyle;
